import { render, staticRenderFns } from "./LinkedCompItem.vue?vue&type=template&id=1ad0e0d4&scoped=true&"
import script from "./LinkedCompItem.vue?vue&type=script&lang=js&"
export * from "./LinkedCompItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCompItem.vue?vue&type=style&index=0&id=1ad0e0d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0e0d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default})
